export const FORM_EVENT_DELAY: number = 100;

export const FORM_PROPS = {
  noValidate: true,
  autoComplete: 'off'
};

export const FORM_RESET_DIALOG_TITLE = 'Reset Form?';
export const FORM_RESET_DIALOG_MESSAGE = 'This action cannot be undone.';